export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/ryUHZoDc3BiirtLtkEFHuJ/0503b676-9c29-4c30-9bce-7b33592fadec.webp",
  productBox: "https://cdn.magicpatterns.com/uploads/ryUHZoDc3BiirtLtkEFHuJ/0503b676-9c29-4c30-9bce-7b33592fadec.webp",
  workbench: "https://cdn.magicpatterns.com/patterns/generated-images/d97812c5-c8c7-4c0e-9f89-39b83364cfb1.jpg",
  transformBench: "https://cdn.magicpatterns.com/patterns/generated-images/3daa9529-8fa8-4d9e-93f9-98a1a2327100.jpg",
  outdoor: "https://cdn.magicpatterns.com/patterns/generated-images/dadead0e-0a32-4ab4-bf53-efec5bbee985.jpg",
  drillStation: "https://cdn.magicpatterns.com/patterns/generated-images/644f4720-0a0a-40dc-8b5d-b41a4e66d468.jpg",
  chair: "https://cdn.magicpatterns.com/patterns/generated-images/46b2bfc9-5f48-4682-9560-5b961d91672e.jpg",
  shelf: "https://cdn.magicpatterns.com/patterns/generated-images/0044a435-caef-473a-b0da-f2477a0cbad4.jpg",
  blueprint: "https://cdn.magicpatterns.com/patterns/generated-images/2002fa71-bfaa-44cb-9450-9158c2700511.jpg",
};

export const insidePages = {
  movement: "https://cdn.magicpatterns.com/uploads/cvUsF7g2tRYKXrRVMzt1iw/Captura-de-pantalla-2026-09-25-a-la_s_-8.22.22_p._m..webp",
  ladderChair: "https://cdn.magicpatterns.com/uploads/dBd3SUoucL7ZwadtsEnjPi/Captura-de-pantalla-2026-09-25-a-la_s_-8.23.03_p._m..webp",
  outdoorBar: "https://cdn.magicpatterns.com/uploads/ewAERT2muMoXJaKVCwcvhY/Captura-de-pantalla-2026-09-25-a-la_s_-8.24.51_p._m..webp",
  stepStool: "https://cdn.magicpatterns.com/uploads/qH7pXHpDULFLa5KkhXtqG7/Captura-de-pantalla-2026-09-25-a-la_s_-8.25.34_p._m..webp",
  mirrorCabinet: "https://cdn.magicpatterns.com/uploads/fV7MGCYHtUtH8FgEovP3tP/Captura_de_pantalla_2026-09-25_a_la(s)_8.27.46_p.webp",
};

export const insideGallery = [
  { src: insidePages.ladderChair, title: "Ladder Chair", caption: "Chair → Step ladder" },
  { src: insidePages.outdoorBar, title: "Fold-Away Outdoor Bar", caption: "Wall cabinet → Serving bar" },
  { src: insidePages.stepStool, title: "Chair → Step Stool", caption: "Compact chair → Multi-step stool" },
  { src: insidePages.mirrorCabinet, title: "Mirror → Hidden Cabinet", caption: "Wall mirror → Storage cabinet" },
];

export const price = { current: "US$27", original: "US$97", discount: "-72%" };

export const heroStats = [
  { value: "150", label: "Ready-to-build projects" },
  { value: "6", label: "Complete volumes" },
  { value: "25", label: "Transformable 2-in-1 builds" },
  { value: "5", label: "Premium bonus guides" },
];

export const testimonials = [
  { name: "Mike T.", location: "Austin, TX", text: "The plans are crystal clear. I finished my first bench in a single weekend without wasting a board. The cut list alone saved me hours." },
  { name: "Rachel K.", location: "Portland, OR", text: "I'd never built anything before, and now there's a ladder shelf in my living room. The step-by-step guides make it easy to follow along." },
  { name: "David L.", location: "Toronto, CA", text: "I walk into the lumber yard with everything already calculated. Five projects in and each one has turned out better than the last." },
  { name: "Jenna W.", location: "Denver, CO", text: "The 2-in-1 designs are brilliant. The bench that flips into a picnic table is the most-used thing in our backyard." },
];

export const knowList = [
  "What materials you need",
  "What pieces to cut",
  "What dimensions to use",
  "How every part connects",
  "What order to assemble it in",
  "How the final project should look",
  "How transformable projects move from one function to another",
];

export const collectionFeatures = [
  "Exact Inch + Metric Measurements",
  "Complete Cutting Lists",
  "Step-by-Step Visual Instructions",
  "Technical Front, Side & Top Views",
  "Exploded Assembly Diagrams",
  "Material & Hardware Guidance",
  "Beginner-Friendly Projects",
  "Workshop & Garage Builds",
  "Home Furniture",
  "Outdoor & Garden Projects",
  "25 Transformable 2-in-1 Designs",
  "5 Premium Bonus Guides",
];

export const offerHighlights = [
  { bold: "150 Ready-to-Build Projects", rest: "for home, workshop, outdoor, storage & pets — plus 25 smart 2-in-1 designs." },
  { bold: "Exact Inch + Metric Measurements", rest: "on every plan" },
  { bold: "Step-by-Step Visual Instructions", rest: "with every project" },
  { bold: "Complete Cutting Lists", rest: "for all parts and pieces" },
  { bold: "Technical Views & Exploded Diagrams", rest: "— front, side and top" },
  { bold: "Material & Hardware Guidance", rest: "so you know what to buy" },
  { bold: "Beginner-Friendly Projects", rest: "that progress into more involved builds" },
  { bold: "Bonus: 5 Premium Guides", rest: "— wood, joinery, tools, finishing & cheat sheets" },
];

export const finalOfferHighlights = [
  { bold: "150 Ready-to-Build Woodworking Projects", rest: "across 6 complete volumes" },
  { bold: "25 Smart Transformable 2-in-1 Builds", rest: "that fold, flip and expand" },
  { bold: "Step-by-Step Visual Instructions", rest: "with every project" },
  { bold: "Exact Inch + Metric Measurements", rest: "and complete cutting lists" },
  { bold: "Technical Views & Exploded Diagrams", rest: "for every assembly" },
  { bold: "Material & Hardware Guidance", rest: "before you start cutting" },
  { bold: "Bonus: Wood Selection & Joinery Guides" },
  { bold: "Bonus: Tools, Finishing & Cutting Cheat Sheets" },
];

export const problemLines = [
  "The measurements are missing.",
  "The cutting list is incomplete.",
  "The assembly steps are unclear.",
  "And with transformable furniture, you're left wondering how the mechanism is even supposed to work.",
];

export const noMoreLines = [
  "No random guessing.",
  "No designing every project from zero.",
  "No trying to reverse-engineer furniture from a photo.",
];

export type FeatureBlockData = {
  id: string;
  title: string;
  accent: string;
  paragraphs: string[];
  checks: string[];
  checkColumns?: 1 | 2;
  afterChecks?: string;
  points?: string[];
  closing?: string;
  image: string;
  imageAlt: string;
  imageIsPage?: boolean;
  reverse?: boolean;
  cta?: string;
};

export const confidenceBlock: FeatureBlockData = {
  id: "confidence",
  title: "Build with confidence",
  accent: "No need to be a professional woodworker",
  paragraphs: [
    "Our plans are designed to make woodworking easier to understand.",
    "With clear visuals, exact dimensions, cutting lists, component labels, exploded diagrams, and step-by-step assembly guidance, you can quickly understand:",
  ],
  checks: [
    "What to cut",
    "Where each piece goes",
    "How components connect",
    "Where hardware is installed",
    "How to keep assemblies square",
    "How transformable parts move",
    "What the completed build should look like",
  ],
  afterChecks: "Forget vague sketches.",
  points: ["Clear instructions", "Practical measurements", "Organized cut lists", "Visual assembly sequences", "Less guesswork from start to finish"],
  closing: "Choose the project. Follow the plan. Build it.",
  image: insidePages.mirrorCabinet,
  imageAlt: "Inside page: Mirror to hidden storage cabinet plan with snapshot, materials, cut list and elevations",
  imageIsPage: true,
  cta: "Download now",
};

export const workshopBlock: FeatureBlockData = {
  id: "workshop",
  title: "Build a workshop that works for you",
  accent: "Design smarter. Not harder.",
  paragraphs: [
    "A better workspace changes the way you build.",
    "When your tools are organized, your workbench makes sense, and your setup is designed around real work, you spend less time moving things around and more time actually building.",
    "Inside the collection, you'll find practical workshop projects designed to help you create:",
  ],
  checks: [
    "Functional workbenches",
    "Mobile workshop stations",
    "Tool storage systems",
    "Lumber storage",
    "Clamp racks",
    "Cutting stations",
    "Compact work surfaces",
    "Folding workshop setups",
    "Rolling utility stations",
  ],
  checkColumns: 2,
  afterChecks: "Every project includes clear plans, exact measurements, and organized cutting information.",
  closing: "Start with the workspace, and every future project gets easier.",
  image: images.workbench,
  imageAlt: "Wooden workbench with drawers and a tool wall",
  reverse: true,
};

export const transformVerbs = ["Folds", "Flips", "Expands", "Transforms"];

export const transformations = [
  { from: "Folding picnic bench", to: "Picnic table", text: "A comfortable outdoor bench that transforms into a full picnic table." },
  { from: "Wall cabinet", to: "Fold-down desk", text: "A compact wall unit that opens into a practical workspace." },
  { from: "Chair", to: "Step ladder", text: "A functional chair that converts into a compact step ladder." },
  { from: "Compact workbench", to: "Full workstation", text: "Save floor space when you're not building, then open it when it's time to work." },
  { from: "Console table", to: "Larger table", text: "A narrow piece of furniture that expands when you need more usable surface." },
  { from: "Wall shelf", to: "Mini desk", text: "A clean wall-mounted shelf that becomes a compact writing or laptop station." },
  { from: "Outdoor cabinet", to: "Fold-away bar", text: "A compact storage unit that opens into a practical serving area." },
];

export const transformIncludes = [
  "Closed-state dimensions",
  "Open-state dimensions",
  "Hardware location",
  "Pivot and hinge guidance",
  "Movement diagrams",
  "Component cut lists",
  "Assembly sequence",
  "Stability checkpoints",
];

export const categories = [
  { icon: "home", title: "Home", text: "Tables, benches, shelves, cabinets, desks, storage, and practical furniture." },
  { icon: "workshop", title: "Workshop", text: "Workbenches, tool organization, mobile stations, storage systems, and space-saving setups." },
  { icon: "outdoor", title: "Outdoor", text: "Garden furniture, planters, picnic tables, outdoor storage, and backyard projects." },
  { icon: "twoInOne", title: "2-in-1", text: "Transformable furniture that folds, expands, flips, or changes function." },
  { icon: "pets", title: "Pets & Family", text: "Dog houses, feeding stations, kids furniture, toy storage, and creative home builds." },
];

export const visualChecks = [
  "Finished-project visuals",
  "Front views",
  "Side views",
  "Top views",
  "Isometric drawings",
  "Exploded diagrams",
  "Component labels",
  "Dimension arrows",
  "Hardware locations",
  "Transformation sequences",
];

export const transformableBuilds = [
  { icon: "outdoor", title: "Folding picnic bench / table", lines: ["Use it as a bench when you want compact outdoor seating.", "Transform it into a picnic table when you need more space for meals, gatherings, or projects."] },
  { icon: "home", title: "Wall cabinet / fold-down desk", lines: ["Keep your room clean and open when the desk isn't being used.", "Open the cabinet and transform it into a functional workspace."] },
  { icon: "workshop", title: "Folding workbench", lines: ["Get a real working surface when you need it.", "Fold or compact the setup when you need your garage space back."] },
  { icon: "chair", title: "Chair / step ladder", lines: ["Two useful functions built into one woodworking project."] },
  { icon: "table", title: "Console / expanded table", lines: ["Compact when you need space.", "Larger when you need additional working or dining surface."] },
];

export const galleryImages = [
  { src: images.transformBench, alt: "Bench that transforms into a picnic table" },
  { src: images.chair, alt: "Wooden dining chair" },
  { src: images.shelf, alt: "Ladder shelf" },
  { src: images.outdoor, alt: "Garden playhouse" },
  { src: images.workbench, alt: "Workbench" },
  { src: images.drillStation, alt: "Drill press station" },
];

export type Volume = {
  number: string;
  title: string;
  subtitle: string;
  intro: string;
  listLabel: string;
  items: string[];
  more?: boolean;
  tags?: string[];
  tagline?: string;
  featured?: boolean;
};

export const volumes: Volume[] = [
  {
    number: "01",
    title: "Weekend Builds",
    subtitle: "25 Practical Beginner-Friendly Projects",
    intro: "Start with useful projects designed around accessible tools, straightforward construction, and practical woodworking skills.",
    listLabel: "Build:",
    items: ["Storage Crates", "Wall Shelves", "Entryway Benches", "Step Stools", "Shoe Racks", "Plant Stands", "Coffee Tables", "Bookshelves", "Side Tables", "Desks", "Utility Carts", "Workbenches"],
    more: true,
  },
  {
    number: "02",
    title: "Transformable Builds",
    subtitle: "25 Ingenious 2-in-1 & Space-Saving Projects",
    intro: "The most innovative volume in the collection.",
    listLabel: "Build projects that:",
    items: ["Fold", "Flip", "Expand", "Rotate", "Open", "Close", "Transform"],
    tags: ["Home", "Workshop", "Garden", "Small spaces", "Apartments", "Garages"],
    tagline: "One build. Two purposes.",
    featured: true,
  },
  {
    number: "03",
    title: "Home Furniture",
    subtitle: "25 Ready-to-Build Furniture Projects",
    intro: "Build practical pieces for your home.",
    listLabel: "Including:",
    items: ["Coffee Tables", "Nightstands", "Console Tables", "Bookshelves", "TV Stands", "Dining Benches", "Desks", "Cabinets", "Kitchen Storage", "Sideboards", "Bedroom Furniture"],
    more: true,
  },
  {
    number: "04",
    title: "Outdoor & Garden",
    subtitle: "25 Projects for Your Backyard, Patio & Garden",
    intro: "Make the most of your outdoor space with durable, practical builds.",
    listLabel: "Build:",
    items: ["Outdoor Tables", "Garden Benches", "Adirondack-Style Seating", "Planters", "Raised Garden Beds", "Potting Benches", "Firewood Storage", "Picnic Tables", "Outdoor Bars", "Garden Organization"],
    more: true,
  },
  {
    number: "05",
    title: "Workshop & Garage",
    subtitle: "25 Projects Designed to Improve the Way You Build",
    intro: "Upgrade the space where every other project happens.",
    listLabel: "Create:",
    items: ["Workbenches", "Assembly Tables", "Mobile Tool Carts", "Miter Saw Stations", "Tool Storage", "Lumber Racks", "Clamp Racks", "Drill Stations", "Rolling Workstations", "Garage Organization"],
    more: true,
  },
  {
    number: "06",
    title: "Pets, Kids & Creative Builds",
    subtitle: "25 Useful & Creative Woodworking Projects",
    intro: "Fun, useful builds for the whole family — furry members included.",
    listLabel: "Build:",
    items: ["Dog Houses", "Feeding Stations", "Cat Furniture", "Kids Tables", "Toy Storage", "Montessori Shelves", "Play Furniture", "Game Tables", "Artist Stations", "Backyard Builds"],
    more: true,
  },
];

export const bonusCards = [
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/2496f5da-a655-4fe5-819e-298893092f36.jpg",
    title: "Wood Selection Master Guide",
    tagline: "Know what to buy before you start cutting.",
    highlights: ["11 wood types compared", "Indoor vs. outdoor", "Inspect boards"],
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/cc4d1589-69e2-42a9-805c-e0b2faa2c9b3.jpg",
    title: "Essential Joinery Guide",
    tagline: "Understand how every piece connects.",
    highlights: ["Pocket holes & dowels", "Half-laps & dados", "Hinges & pivots"],
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/bb5b49be-6784-425b-a70c-91438114ee3e.jpg",
    title: "Woodworking Tools Master Guide",
    tagline: "Know what tool to use — and when.",
    highlights: ["Saws & drills", "Clamps & sanders", "Budget alternatives"],
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/ded5eb9d-76e8-498d-9677-dad720406df9.jpg",
    title: "Finishing & Staining Guide",
    tagline: "A good build deserves a good finish.",
    highlights: ["Sanding steps", "Paint, stain & oils", "Outdoor finishes"],
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/8f9fe7a6-bd80-4769-82b9-2bb0b1873a45.jpg",
    title: "Measurement & Cutting Cheat Sheets",
    tagline: "Printable quick-reference for your shop.",
    highlights: ["Inch ↔ metric", "Lumber sizes", "Cut planning"],
  },
];

export type Bonus = {
  title: string;
  subtitle: string;
  intro: string[];
  listLabel: string;
  items: string[];
  extraLabel?: string;
  extraItems?: string[];
  outro: string;
};

export const bonuses: Bonus[] = [
  {
    title: "Wood Selection Master Guide",
    subtitle: "Choose the Right Wood for Every Project",
    intro: ["Stop wondering which wood you should buy."],
    listLabel: "Learn how to compare:",
    items: ["Pine", "Spruce", "Poplar", "Oak", "Maple", "Ash", "Cedar", "Birch", "Plywood", "MDF", "OSB"],
    extraLabel: "Also discover:",
    extraItems: ["Indoor vs. Outdoor Materials", "Paint vs. Stain", "Nominal vs. Actual Lumber Sizes", "How to Inspect Boards", "Bow, Cup, Twist & Crook", "Budget vs. Premium Material Options"],
    outro: "Know what to buy before you start cutting.",
  },
  {
    title: "Essential Joinery Guide",
    subtitle: "Master the Connections Behind Every Build",
    intro: ["Understand the most useful woodworking connections with clear visual guidance."],
    listLabel: "Includes:",
    items: ["Butt Joints", "Screw + Glue Construction", "Pocket Holes", "Dowels", "Half-Lap Joints", "Rabbets", "Dados", "Cleats", "Brackets", "Hinges", "Pivot Connections", "Predrilling", "Clamping", "Checking for Square"],
    outro: "Understand how the pieces connect before you assemble them.",
  },
  {
    title: "Woodworking Tools Master Guide",
    subtitle: "Know What Tool to Use — and When",
    intro: ["A practical visual guide to the tools used across common woodworking projects."],
    listLabel: "Learn the purpose of:",
    items: ["Tape Measures", "Squares", "Drills & Drivers", "Circular Saws", "Miter Saws", "Sanders", "Clamps", "Drill Bits", "Saw Blades", "Hand Tools", "Workshop Accessories"],
    outro: "Includes beginner-friendly explanations and practical alternatives when you don't own every tool.",
  },
  {
    title: "Finishing & Staining Guide",
    subtitle: "Take Your Project From Raw Wood to Finished Piece",
    intro: ["Learn the fundamentals of preparing and finishing woodworking projects."],
    listLabel: "Includes:",
    items: ["Surface Preparation", "Sanding Progressions", "Paint", "Stain", "Clear Finishes", "Oils", "Outdoor Finishes", "Between-Coat Preparation", "Testing Finish on Scrap", "Common Finishing Mistakes"],
    outro: "A good build deserves a good finish.",
  },
  {
    title: "Measurement & Cutting Cheat Sheets",
    subtitle: "Your Workshop Quick-Reference Pack",
    intro: ["Keep important woodworking references within reach."],
    listLabel: "Includes:",
    items: ["Inch + Metric Conversion References", "Fraction Guides", "Common Lumber Dimensions", "Measuring & Marking Checklist", "Saw Kerf Reminder", "Cut Planning", "Component Labeling", "Square-Checking Guide", "Cutting Workflow", "Final Build Checklist"],
    outro: "Designed to be printed and kept in your workshop.",
  },
];

export const youGet = [
  "150 Ready-to-Build Woodworking Projects",
  "6 Complete Project Volumes",
  "25 Smart Transformable 2-in-1 Builds",
  "125 Additional Practical Woodworking Projects",
  "Step-by-Step Visual Instructions",
  "Exact Inch + Metric Measurements",
  "Complete Cutting Lists",
  "Technical Views",
  "Exploded Assembly Diagrams",
  "Material & Hardware Guidance",
];

export const plusBonuses = bonuses.map((b) => b.title);

export const steps = [
  { title: "Choose your project", text: "Pick the build you want from the complete collection." },
  { title: "Check the materials", text: "See what wood, hardware, and tools the project requires." },
  { title: "Follow the cut list", text: "Prepare each component using the project measurements." },
  { title: "Study the plan", text: "See how the components fit together before assembly." },
  { title: "Build step by step", text: "Follow the visual construction sequence." },
  { title: "Verify & finish", text: "Check alignment, sand the project, apply the appropriate finish, and complete the build." },
];

export const differentPros = [
  "150 Organized Projects",
  "Inch + Metric Measurements",
  "Complete Cut Lists",
  "Step-by-Step Visual Guidance",
  "Technical Drawings",
  "Exploded Views",
  "25 Transformable 2-in-1 Projects",
  "6 Organized Volumes",
  "5 Practical Bonus Guides",
  "Digital Access",
];

export const differentCons = [
  "Missing measurements",
  "Incomplete instructions",
  "Unclear cuts",
  "No consistent structure",
  "Different formats everywhere",
  "Difficult-to-understand diagrams",
  "Hours spent searching for missing information",
];

export type FaqItem = { q: string; a: string[]; list?: string[] };

export const faqs: FaqItem[] = [
  { q: "What exactly do I receive?", a: ["You receive the complete WOODWORKING READY™ collection: 6 volumes × 25 projects = 150 woodworking projects, plus 5 premium bonus guides."] },
  { q: "Are these physical books?", a: ["No. WOODWORKING READY™ is a digital product delivered as downloadable resources.", "There are no physical books or woodworking materials shipped to your home."] },
  { q: "Can I print the plans?", a: ["Yes. The files are designed to be used digitally or printed for workshop reference."] },
  { q: "Do the projects include measurements?", a: ["Yes. The plans use both imperial and metric measurements."] },
  { q: "Are cutting lists included?", a: ["Yes. Projects include organized component and cutting information to help you prepare the pieces required for the build."] },
  { q: "What are the 2-in-1 projects?", a: ["Volume 02 contains 25 transformable and space-saving projects designed around two functions or configurations. Examples include:"], list: ["Bench → picnic table", "Cabinet → desk", "Chair → step ladder", "Compact workstation → expanded work surface"] },
  { q: "Are the plans suitable for beginners?", a: ["The collection includes many beginner-friendly projects and progresses into more involved builds.", "Each project shows its materials, dimensions, construction information, and assembly guidance."] },
  { q: "Do I need professional workshop equipment?", a: ["Many projects use common woodworking tools and straightforward construction methods.", "Each project identifies the tools required so you can check what you need before starting."] },
  { q: "What kind of projects are included?", a: ["The collection covers:"], list: ["Home furniture", "Workshop projects", "Outdoor and garden builds", "Storage solutions", "2-in-1 transformable furniture", "Pet projects", "Kids projects", "Creative DIY builds"] },
  { q: "What are the 5 bonus guides?", a: ["You receive:"], list: bonuses.map((b) => b.title) },
];

export const finalFeatures = ["Exact Measurements", "Cutting Lists", "Technical Plans", "Step-by-Step Builds"];
